/**
 * Supabase inbound presenter.
 */
import type { InboundProviderPresenter } from '@/lib/integrations/inbound/types'

import {
  SUPABASE_EVENT_CATEGORIES,
  SUPABASE_EVENT_METADATA,
} from './supported-events'

/**
 * Supabase doesn't ship native signing — the operator creates a shared
 * signing secret (e.g. `openssl rand -hex 32`, no required prefix) and pastes
 * it into both the setup SQL and the Connect form. The
 * connect handler enforces a minimum length so a typo'd value can't
 * silently trick a tenant into thinking signing is wired up.
 */
export const SUPABASE_SIGNING_SECRET_MIN_LENGTH = 16

export const supabaseInboundPresenter: InboundProviderPresenter = {
  providerId: 'supabase',
  displayName: 'Supabase',
  categories: SUPABASE_EVENT_CATEGORIES,
  events: SUPABASE_EVENT_METADATA,
  defaultTriggerLoop: true,
  triggerEventId({ orgId, brandId, eventType }) {
    return `supabase:${orgId}:${brandId}:${eventType}`
  },
}
